// extracted by mini-css-extract-plugin
module.exports = {"reviewsHeader":"header_reviewsHeader__7CXNr","subtitle":"header_subtitle__NBiXs"};